module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("blog_post_link_with_title", [["if",{"notempty":"","addattr":"href:/post/&&1&&/&&2&&"},[["else",{"addattr":"href:/post/&&0&&"},[],[["id","addattr"]]]],[["title","notempty",true],["id","addattr"],["title","addattr",false,[{"name":"toNavigatorAlias","params":[]}]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/blog/commonImport.tpl
// module id = 709
// module chunks = 4